module.exports = __webpack_public_path__ + "dist/media/logo--lt.dc714e4f.svg";